/**
 * AWS Amplify Configuration
 * Generated configuration for Cognito authentication
 * Uses existing environment variables from cognito.config.ts
 */

import { getFrontendUrl } from './utils/environment.config';

// Get Cognito configuration from environment variables
const userPoolId = process.env.REACT_APP_COGNITO_POOL_ID || '-';
const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID || '-';
const domain = process.env.REACT_APP_COGNITO_DOMAIN || '-';
const frontendUrl = getFrontendUrl();

// Amplify configuration object for v6
const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: userPoolId,
      userPoolClientId: clientId,
      loginWith: {
        oauth: {
          domain: domain,
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: [`${frontendUrl}/`, `${frontendUrl}/search-assets`],
          redirectSignOut: [`${frontendUrl}/`], // Redirect to home - Authenticator will show login UI
          responseType: 'code' as const, // Use authorization code flow with PKCE
        },
        email: true, // Use email for sign-in
      },
    },
  },
};

export default awsConfig;
